<template>
	<div class="personCont">
      
      <div v-if="showdata==1">
        <div class="title f-20 cf">
          <div class="fl cf">
			<div class="srNavItem" @click="sendTabMenu('supply')">我的供需</div>
          	<div class="srNavItem on">我的招聘</div>
          </div>
          <div class="fr cf f-14">
            <div class="supplySearch cf fl">
              <input type="text" v-model="keyword" name="keyword" placeholder="请输入内容" @keyup.enter="searchFun">
              <button @click="searchFun" type="button">&nbsp;</button>
            </div>

            <div class="supplyPubBtn fl" @click="pubSupply">发布招聘</div>
          </div>
        </div>
        
        <div class="supplyTable recruitTable" v-if="noMessage==false">
          <table>
            <tr>
              <th>公司</th>
              <th>职位名称</th>
              <th>薪资</th>
              <th>福利</th>
              <th>工作地点</th>
			  <th>状态</th>
              <th>审核状态</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item,index) in list">
              <td>{{item.corporateName}}</td>
              <td>{{item.title}}</td>
              <td>
				<el-select v-model="item.salary" placeholder="请选择" disabled :class="'hx-disabled'">
				    <el-option
				      v-for="g in salaryOptions"
				      :key="g.value"
				      :label="g.title"
				      :value="g.value">
				    </el-option>
				</el-select>
              </td>
              <td>{{item.benefits}}</td>
              <td>{{item.address}}</td>
			  
			 <!--  <td>{{item.status_dictText}}</td> -->
			  <!-- <td v-if="item.finishStatus=='Y'">已完成</td>
              <td v-else>进行中</td> -->
		
              <td v-if="item.finishStatus=='Y'">已完成</td>
              <td v-else-if="item.status==1">进行中</td>
              <td v-else>未发布</td>
              

              <!-- <td>{{item.checkStatus_dictText}}</td> -->
              <td v-if="item.checkStatus==1">审核成功</td>
              <td v-else-if="item.checkStatus==2">未通过</td>
              <td v-else>待审核</td>

              <td>
                <span class="btn" @click="toSee(item.id)">查看</span>
                <span class="btn" v-if="item.status!=1&&item.status!=5" @click="toEdit(item.id)">编辑</span>
                <template v-if="item.checkStatus==1">
	                <span class="btn" v-if="item.status==0" @click="toPublish(item.id)">发布</span>
	                <span class="btn" v-if="item.status==1" @click="unPublish(item.id)">下架</span>
                </template>
              </td>
            </tr>
          </table>
        </div>
        
        <div class="mt80" v-if="noMessage==false">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentpage"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalnum">
          </el-pagination>
        </div>

        <div style="text-align:center;padding-top:50px;" v-if="noMessage==true">暂无内容</div>
      </div>

      <div v-if="showdata==2">
        <div class="title f-20 cf">发布招聘<span @click="showdata=1" class="back f-16">返回</span></div>

        <div class="personResetForm">
          
          <div class="item cf">
            <div class="name fl">公司名称<span>*</span></div>
            <div class="txt ovh"><input type="text" v-model="corporateName" name="corporateName" placeholder="请输入公司名称"></div>
          </div>
          <div class="item cf">
            <div class="name fl">职位名称<span>*</span></div>
            <div class="txt ovh"><input type="text" v-model="title" name="title" placeholder="请输入职位名称"></div>
          </div>
          <div class="item cf">
            <div class="name fl">职位介绍<span>*</span></div>
            <div class="txt ovh"><textarea v-model="intro" placeholder="职位介绍"></textarea></div>
          </div>
          <div class="item cf">
            <div class="name fl">学&emsp;&emsp;历<span>*</span></div>
            <div class="txt ovh">
              	<el-select v-model="qualificationType" placeholder="请选择">
				    <el-option
				      v-for="item in qualificationOptions"
				      :key="item.value"
				      :label="item.title"
				      :value="item.value">
				    </el-option>
				</el-select>
            </div>
          </div>
          <div class="item cf">
            <div class="name fl">薪资待遇<span>*</span></div>
            <div class="txt ovh">
              	<el-select v-model="salary" placeholder="请选择">
				    <el-option
				      v-for="item in salaryOptions"
				      :key="item.value"
				      :label="item.title"
				      :value="item.value">
				    </el-option>
				</el-select>
            </div>
          </div>
          
          <div class="item cf">
            <div class="name fl">福&emsp;&emsp;利&nbsp;&nbsp;</div>
            <div class="txt ovh"><input type="text" v-model="benefits" name="benefits" placeholder="请输入福利"></div>
          </div>
		  
		  <div class="item cf">
            <div class="name fl">工作地点<span>*</span></div>
            <div class="txt ovh">
              	<!-- <input type="text" v-model="address" name="address" placeholder="工作地点"> -->
				<div class="recruitAreaSelect">
	                <el-select v-model="addressProvince" placeholder="请选择省" @change="selectProvince">
	                  <el-option
	                    v-for="(item,index) of pOptions"
	                    :key="index"
	                    :label="item.title"
	                    :value="item.id">
	                  </el-option>
	                </el-select>
	                <el-select v-model="addressCity" placeholder="请选择市" @change="selectCity">
	                  <el-option
	                    v-for="(item,index) of cOptions"
	                    :key="index"
	                    :label="item.title"
	                    :value="item.id">
	                  </el-option>
	                </el-select>
	                <el-select v-model="addressDistrict" placeholder="请选择区" @change="selectArea">
	                  <el-option
	                    v-for="(item,index) of dOptions"
	                    :key="index"
	                    :label="item.title"
	                    :value="item.id">
	                  </el-option>
	                </el-select>
                </div>
            </div>
          </div>

          <div class="item cf">
            <div class="name fl">其他特殊要求</div>
            <div class="txt ovh"><textarea v-model="otherIntro" placeholder="其他特殊要求"></textarea></div>
          </div>
          
          <div class="item cf">
            <div class="name fl">&emsp;</div>
            <div class="ovh"><div class="sub f-16" @click="subSupplyFun">提交</div></div>
          </div>
        </div>
      </div>

      <div v-if="showdata==3">
        <div class="title f-20 cf">发布招聘 <span @click="showdata=1" class="back f-16">返回</span></div>

        <div class="personResetForm">
          
          <div class="item cf">
            <div class="name fl">公司名称<span>*</span></div>
            <div class="ovh">{{corporateName}}</div>
          </div>
          <div class="item cf">
            <div class="name fl">职位名称<span>*</span></div>
            <div class="ovh">{{title}}</div>
          </div>
          <div class="item cf">
            <div class="name fl">职位介绍<span>*</span></div>
            <div class="ovh">{{intro}}</div>
          </div>
          <div class="item cf">
            <div class="name fl">学&emsp;&emsp;历<span>*</span></div>
            <div class="ovh">
				<el-select v-model="qualificationType" placeholder="请选择" disabled :class="'hx-disabled'">
				    <el-option
				      v-for="item in qualificationOptions"
				      :key="item.value"
				      :label="item.title"
				      :value="item.value">
				    </el-option>
				</el-select>
            </div>
          </div>
          <div class="item cf">
            <div class="name fl">薪资待遇:</div>
            <div class="ovh">
				<el-select v-model="salary" placeholder="请选择" disabled :class="'hx-disabled'">
				    <el-option
				      v-for="item in salaryOptions"
				      :key="item.value"
				      :label="item.title"
				      :value="item.value">
				    </el-option>
				</el-select>
            </div>
          </div>

          <div class="item cf">
            <div class="name fl">福&emsp;&emsp;利&nbsp;&nbsp;</div>
            <div class="ovh">{{benefits}}</div>
          </div>
          
          <div class="item cf">
            <div class="name fl">工作地点<span>*</span></div>
            <div class="ovh">{{address}}</div>
          </div>
          
          <div class="item cf">
            <div class="name fl">其他特殊要求</div>
            <div class="ovh">{{otherIntro}}</div>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
import { getAreaInfo , getAreaDotInfo } from "@/api/login/login";
import { recruitList , recruitQuery , recruitUpdatePublic , recruitEdit , recruitAdd , queryDictItemsByCode } from "@/api/person/person";
import { 
  getEnterpriseInfo
} from "@/api/tableapi";
import layer from "layui-layer";
export default {
	name: 'recruit',
	data(){
		return{
			showdata:true,

	        totalnum:1,
	        pagesize:10,
	        currentpage:1,
	        list:[],

	        corporateName:'',   			  //公司名称
	        title:"",						  //职位名称
	        intro:"",           			  //职位介绍
	        qualificationType:"",             //学历
	        qualificationText:"",
	        qualificationOptions:[],          //学历选项数据
	        salary:"",                        //薪资
	        salaryText:"",
	        salaryOptions:[],   			  //薪资选项数据
	        benefits:"",        			  //福利
	        address:"",   //工作地点
	        addressProvince:'',
	        addressCity:'',
	        addressDistrict:'',
	        pOptions:[],
	        cOptions:[],
	        dOptions:[],
	        otherIntro:"",                    //其它特殊需求

	        isEdit:true,

	        keyword:'',
	        noMessage:false,

	        options:[],

	        editId:''
		}
	},
	mounted(){
		 let that=this
	    that.initSelectData()
	    that.recruitListFun()
	    //初始化省列表
	    that.initProvinceOptions()
	},
	activated(){
		
	},
	computed:{
		
	},
	methods: {
		recruitListFun(){
	      let that=this
	      let datas="title="+that.keyword+"&pageNo="+that.currentpage+"&pageSize="+that.pagesize
	      recruitList(datas).then(res=>{
	        //console.log(res)
	        if(res.success){
	          if (res.result!=null&&res.result.records.length>0) {
	            that.list=res.result.records
	            that.totalnum=res.result.total
	          }else{

	          }
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },

	    initSelectData(){
	      let that=this
	      
	      //薪资
	      queryDictItemsByCode('dictCode=salaryBenefits').then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.salaryOptions=res.result
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	      //学历
	      queryDictItemsByCode('dictCode=qualificationType').then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.qualificationOptions=res.result
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },

	    //处理没有子项的数据
	    getTypeList(listData) {
	       listData.forEach((items) => {
	          if (items.sub.length > 0) {
	            this.getTypeList(items.sub)
	          } else {
	            items.sub = undefined
	          }
	       })
	    },

	    searchFun(){
	      let that=this
	      // if (that.keyword=='') {
	      //   that.$message.error('请输入搜索关键字')
	      //   return false
	      // }

	      that.currentpage=1
	      that.recruitListFun()
	    },

	    handleSizeChange(val){
	      let that=this
	      that.pagesize=val
	      //console.log(`每页 ${val} 条`);
	      that.recruitListFun()
	    },
	    handleCurrentChange(val){
	      let that=this
	      that.currentpage=val
	      //console.log(`当前页: ${val}`);
	      that.recruitListFun()
	    },

	    pubSupply(){
	      let that=this   
	      	let certificationStatus=that.$store.state.certificationStatus

	      	if(certificationStatus==2){
		      	getEnterpriseInfo().then(res=>{
	              if (res.success) {
	                if(res.result!=null&&res.result!=''){

					      let enterpriseStatus=res.result.status
					      //console.log(enterpriseStatus)
					      if (enterpriseStatus==1) {
					      	that.$message.error("企业认证审核中，通过后可发布招聘，请耐心等待！")
					      }else if(enterpriseStatus==3){
					      	that.$confirm(
				              '企业认证未通过，请重新认证！',
				              '温馨提示',
				              {
				                confirmButtonText: '确定',
				                cancelButtonText: '取消',
				                type: 'warning'
				              }
				            ).then(() => {
				            	that.$router.push({ path: "/person/information" })
				            })
					      }else if(enterpriseStatus==2){
					      
					        that.corporateName=''   //公司名称
					        that.title=""			//职位名称
					        that.intro=""           //职位介绍
					        that.qualificationType=""            //学历
					        that.salary=""          //薪资
					        that.benefits=""        //福利
					        that.address=""         //工作地点
					        that.addressProvince=""
					        that.addressCity=""
					        that.addressDistrict=""
					        that.otherIntro=""      //其它特殊需求

						    that.showdata=2
						    that.isEdit=false
					      }else{
					      	that.$confirm(
				              '请先前往企业认证！',
				              '温馨提示',
				              {
				                confirmButtonText: '确定',
				                cancelButtonText: '取消',
				                type: 'warning'
				              }
				            ).then(() => {
				            	that.$router.push({ path: "/person/information" })
				            })
					      }
					}else{
	                  	that.$confirm(
			              '请先前往企业认证！',
			              '温馨提示',
			              {
			                confirmButtonText: '确定',
			                cancelButtonText: '取消',
			                type: 'warning'
			              }
			            ).then(() => {
			            	that.$router.push({ path: "/person/information" })
			            })
	                }
	              }else{
	              	that.$message.error(res.message)
	              }
	            })
		      }else if(certificationStatus==0){
		      	that.$confirm(
	              '请先前往个人认证！',
	              '温馨提示',
	              {
	                confirmButtonText: '确定',
	                cancelButtonText: '取消',
	                type: 'warning'
	              }
	            ).then(() => {
	            	that.$router.push({ path: "/person/information" })
	            })
		      }else if(certificationStatus==1){
		      	that.$message.error("个人认证审核中，通过后可申请企业认证，请耐心等待！")
		      }else{
		      	that.$confirm(
	              '个人认证未通过审核，请重新认证！',
	              '温馨提示',
	              {
	                confirmButtonText: '确定',
	                cancelButtonText: '取消',
	                type: 'warning'
	              }
	            ).then(() => {
	            	that.$router.push({ path: "/person/information" })
	            })
		      }
	    },

	    //发布
	    toPublish(id){
	      let that=this  
	      let datas="id="+id+"&status=1"
	      recruitUpdatePublic(datas).then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.recruitListFun()
	          that.$message.success("发布成功")
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },
	    //下架
	    unPublish(id){
	      let that=this  
	      let datas="id="+id+"&status=0"
	      recruitUpdatePublic(datas).then(res=>{
	        //console.log(res)
	        if(res.success){
	          that.recruitListFun()
	          that.$message.success("撤销成功")
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },

	    toEdit(id){
	      let that=this      
	      that.showdata=2
	      that.isEdit=true

	      that.infoFun(id)
	      that.editId=id
	    },

	    toSee(id){
	      let that=this      
	      that.showdata=3

	      that.infoFun(id)
	    },

	    //详情
	    infoFun(id){
	      let that=this
	      let datas="id="+id
	      recruitQuery(datas).then(res=>{
	        //console.log(res)
	        if(res.success){
	        	that.corporateName=res.result.corporateName   //公司名称
		        that.title=res.result.title			//职位名称
		        that.intro=res.result.intro           //职位介绍
		        that.qualificationType=res.result.qualificationType            //学历
		        that.salary=res.result.salary          //薪资
		        that.benefits=res.result.benefits        //福利
		        that.otherIntro=res.result.otherIntro      //其它特殊需求
		        that.address=res.result.address
		        that.addressProvince=res.result.addressProvince
		        that.addressCity=res.result.addressCity
		        that.addressDistrict=res.result.addressDistrict

		        //渲染三级联动的市和区
		        if(that.addressProvince!=''&&that.addressProvince!=null){
		        	getAreaInfo(that.addressProvince).then(res => {
			            if (res.success) {
			            	that.cOptions=res.result
				        }else{
			              	that.$message({
				                message: '请求错误，请稍后重试~',
				                type: 'fail'
			              	});
		            	}	
		           	})
		        }
		        if(that.addressCity!=''&&that.addressCity!=null){
		        	getAreaInfo(that.addressCity).then(res => {
			            if (res.success) {
			            	that.dOptions=res.result
				        }else{
			              	that.$message({
				                message: '请求错误，请稍后重试~',
				                type: 'fail'
			              	});
		            	}	
		           	})
		        }
	        }else{
	          that.$message.error(res.message)
	          return false
	        }
	      })
	    },

	    //编辑添加提交
	    subSupplyFun(){
	      let that=this

	      if (that.corporateName==''||that.corporateName==null) {
	        that.$message.error("请填写公司名称")
	        return false
	      }
	      if (that.title==''||that.title==null) {
	        that.$message.error("请填写职位名称")
	        return false
	      }
	      if (that.intro==''||that.intro==null) {
	        that.$message.error("请填写职位介绍")
	        return false
	      }
	      if (that.qualificationType==''||that.qualificationType==null) {
	        that.$message.error("请选择学历")
	        return false
	      }
	      if (that.salary==''||that.salary==null) {
	        that.$message.error("请选择薪资待遇")
	        return false
	      }

	      if (that.addressProvince==''||that.addressProvince==null) {
	        that.$message.error("请选择省")
	        return false
	      }

	      if (that.addressCity==''||that.addressCity==null) {
	        that.$message.error("请选择市")
	        return false
	      }

	      if (that.addressDistrict==''||that.addressDistrict==null) {
	        that.$message.error("请选择区")
	        return false
	      }

	      let addressArr=[]
	      that.pOptions.forEach((item,index)=>{
	      	if (item.id==that.addressProvince) {
	      		addressArr.push(item.title)
	      	}
	      })
	      that.cOptions.forEach((item,index)=>{
	      	if (item.id==that.addressCity) {
	      		addressArr.push(item.title)
	      	}
	      })
	      that.dOptions.forEach((item,index)=>{
	      	if (item.id==that.addressDistrict) {
	      		addressArr.push(item.title)
	      	}
	      })

	      let addressStr=addressArr.join("/")

	      let datas={
	        corporateName:that.corporateName,
	        title:that.title,
	        intro:that.intro,
	        qualificationType:that.qualificationType,
	        salary:that.salary,
	        benefits:that.benefits,
	        address:addressStr,
	        addressProvince:that.addressProvince,
	        addressCity:that.addressCity,
	        addressDistrict:that.addressDistrict,
	        otherIntro:that.otherIntro
	      }

	      if (that.isEdit) {
	        datas.id=that.editId
	        //编辑
	        recruitEdit(datas).then(res=>{
	          if(res.success){
	            that.$message.success(res.result)
	            that.showdata=1
	            that.recruitListFun()
	          }else{
	            that.$message.error(res.message)
	            return false
	          }
	        })
	      }else{
	        //添加
	        recruitAdd(datas).then(res=>{
	          if(res.success){
	            that.$message.success(res.result)
	            that.showdata=1
	            that.currentpage=1
	            that.recruitListFun()
	          }else{
	            that.$message.error(res.message)
	            return false
	          }
	        })
	      }
	    },

	    //查找id路径用于反显
	    searchIdFun(object, value) {
	      for (var key in object) {
	          if (object[key].typeCode == value) return [object[key].typeCode];
	          if(object[key].sub && Object.keys(object[key].sub).length > 0){
	              var temp = this.searchIdFun(object[key].sub, value);
	              if (temp) return [object[key].typeCode, temp].flat();
	          }
	      }
	    },

	    //查找title用于展示
	    searchTitFun(object, value) {
	      for (var key in object) {
	          if (object[key].typeCode == value) return [object[key].title];
	          if(object[key].sub && Object.keys(object[key].sub).length > 0){
	              var temp = this.searchTitFun(object[key].sub, value);
	              if (temp) return [object[key].title, temp].flat();
	          }
	      }
	    },

	    //切换供需和招聘
	    sendTabMenu(val){
	    	this.$emit('tabMenu', val);
	    },

	    initProvinceOptions(){
	    	let that=this
	    	getAreaInfo('0').then(res => {
	            if (res.success) {
	            	that.pOptions=res.result
		        }else{
	              	that.$message({
		                message: '请求错误，请稍后重试~',
		                type: 'fail'
	              	});
            	}	
           	})
	    },

		selectProvince(val){
			let that=this
			//更新市列表数据
			that.dOptions=[]
			that.addressCity=""
		    that.addressDistrict=""
			getAreaInfo(val).then(res => {
	            if (res.success) {
	            	that.cOptions=res.result
		        }else{
	              	that.$message({
		                message: '请求错误，请稍后重试~',
		                type: 'fail'
	              	});
            	}	
           	})
		},

		selectCity(val){
			let that=this
			//更新区列表数据
		    that.addressDistrict=""
			getAreaInfo(val).then(res => {
	            if (res.success) {
	            	that.dOptions=res.result
		        }else{
	              	that.$message({
		                message: '请求错误，请稍后重试~',
		                type: 'fail'
	              	});
            	}	
           	})
		},

		selectArea(val){
			let that=this

			that.dOptions.forEach((item,index)=>{

			})
		}
   	}
}
</script>
<style>
.personCont .hx-disabled{max-width:8em;}
.personCont .hx-disabled .el-input__inner{border:none;background:none;padding:0;color:#333333;display:inline;height:1.5em;}
.personCont .el-select.hx-disabled .el-input__icon{display:none;}

.recruitAreaSelect{display:flex;}
.recruitAreaSelect .el-select .el-input__icon{opacity:0;}
.recruitAreaSelect .el-select .el-input__suffix-inner{border-right:1px solid #dddddd;}
.recruitAreaSelect .el-select:last-child .el-input__suffix-inner{border:none;}
</style>




// WEBPACK FOOTER //
// src/components/global/recruit/index.vue